<div
    class="fixed top-[88px] left-[72px] light-background h-[56px] flex flex-row px-20 items-center w-screen overflow-x-scroll no-scroll z-30">
    <div *ngIf="!loader"
        class="lg:w-7/12 lg:fixed left-[260px] flex flex-row justify-start items-center">
        <div class="mx-2 "
            *ngFor="let button of navButton | featureFlag : 'dashboard_sxi' | async">
            <div (click)="routerClick(button)"
                class="flex flex-row p-2 pr-2 items-center rounded-md cursor-pointer justify-center truncate min-w-[125px]"
                matRipple
                [ngClass]="buttonSelected === button.name ? 'theme-background text-white text-btn  bg-[#233e80]' : 'theme-color text-btn bg-white' "
                mat-flat-button>
                <img *ngIf="buttonSelected === button.name"
                    [src]="button.iconName" (error)="$any($event.target).style.display = 'none'"
                    class=" max-w-6 max-h-6 mx-1" />
                <div class="mx-1">{{utils.traslatei18n(button.displayName ===
                    'Sales' ? 'Buyer': button.displayName )}}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loader"
        class="w-full  flex flex-col justify-center   mr-[72px] items-center">
        <!-- <mat-progress-bar  mode="indeterminate"></mat-progress-bar> -->
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>

</div>

<div>

</div>